import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            width={46}
            height={46}
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#prefix__clip__information)" fill="#fff">
                <path d="M23 17.218c-.514 0-.9-.129-1.156-.386-.386-.257-.514-.642-.514-1.156 0-.514.128-.9.514-1.156.385-.257.77-.386 1.156-.386.386 0 .77.129 1.156.386.386.257.514.642.514 1.156 0 .514-.128.9-.514 1.156-.257.257-.642.386-1.156.386zm1.67 3.34v9.38c0 .643-.128 1.157-.514 1.542-.385.386-.642.514-1.156.514-.514 0-.9-.128-1.156-.514-.257-.385-.386-.77-.386-1.413v-9.251c0-.643.129-1.157.386-1.414.256-.385.642-.514 1.156-.514.514 0 .9.129 1.156.514.257.386.514.643.514 1.157z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.754 35.85c-.514 0-1.028-.258-1.285-.772C-.128 29.296-.899 22.23 1.157 15.804 4.24 6.297 13.107 0 23 0c2.442 0 4.883.385 7.196 1.156.77.257 1.156 1.157.9 1.928-.258.642-.772 1.028-1.414 1.028-.129 0-.257 0-.514-.129-2.056-.642-4.112-1.028-6.296-1.028-8.48 0-16.062 5.525-18.889 13.749-1.927 5.654-1.156 11.693 1.928 16.832.257.386.257.771.128 1.157-.128.385-.385.77-.642.9a.981.981 0 01-.643.256zM23 46a23.032 23.032 0 01-14.52-5.14c-.642-.514-.77-1.413-.256-2.184.257-.386.77-.514 1.156-.514.386 0 .643.129.9.386 3.597 2.826 7.966 4.497 12.592 4.497 4.882 0 9.508-1.8 13.106-4.883.257-.257.642-.386 1.028-.386.385 0 .9.129 1.156.514.514.643.514 1.542-.128 2.185C33.922 44.073 28.654 46 23 46zM41.503 35.592c-.257 0-.514-.128-.771-.257-.77-.385-.9-1.413-.514-2.056a20.046 20.046 0 00-3.983-25.441c-.771-.514-.771-1.413-.257-2.056.257-.385.642-.514 1.156-.514.386 0 .771.129 1.028.386 8.48 7.324 10.408 19.659 4.626 29.296-.257.385-.771.642-1.285.642z"
                />
            </g>
            <defs>
                <clipPath id="prefix__clip__information">
                    <path fill="#fff" d="M0 0h46v46H0z" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default SvgComponent
